export class CompanyConfigGroups {

    id!: string;

    benefitsGroupId: number = 0;
    parametersGroupId: number = 0;
    signaturesGroupId: number = 0;
    holidayGroupId: number = 0;
    withholdingsGroupId: number = 0;
    formulasGroupId: number = 0;
    costsPerEmployeesGroupId: number = 0;

}